import createVueApp from '@/common/create_app'

// Styxie derives name from Admin::MobileAppVersions::ConfigurationsController → AdminMobileAppVersionsConfigurations
Styxie.Initializers.AdminMobileAppVersionsConfigurations = {
  index: async(props) => {
    const { default: IndexPage } = await import('@/vue_widgets/admin/wl_configurations/index/index.vue')
    createVueApp(IndexPage, { props })
  },
  show: async(props) => {
    const { default: ShowPage } = await import('@/vue_widgets/admin/wl_configurations/show/index.vue')
    createVueApp(ShowPage, { props })
  },
  new: async(props) => {
    const { default: FormPage } = await import('@/vue_widgets/admin/wl_configurations/form.vue')
    createVueApp(FormPage, { props })
  },
  edit: async(props) => {
    const { default: FormPage } = await import('@/vue_widgets/admin/wl_configurations/form.vue')
    createVueApp(FormPage, { props })
  }
}
